var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconPackage = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", stroke: props.color, strokeWidth: "2.167", strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("g", { transform: "translate(-1.77 -1.051)" },
                React.createElement("path", { d: "M26.5,16l-9.8,5.6" }),
                React.createElement("path", { d: "M26.5,20.3v-8.7c0-0.8-0.4-1.5-1.1-1.9l-7.6-4.3c-0.7-0.4-1.5-0.4-2.2,0L8.1,9.8\n\t\tC7.4,10.2,7,10.9,7,11.7v8.7c0,0.8,0.4,1.5,1.1,1.9l7.6,4.3c0.7,0.4,1.5,0.4,2.2,0l7.6-4.3C26.1,21.8,26.5,21.1,26.5,20.3\n\t\tL26.5,20.3z" }),
                React.createElement("path", { d: "M7.3,10.5l9.5,5.5l9.5-5.5" }),
                React.createElement("path", { d: "M16.8,26.9V16" }),
                React.createElement("path", { d: "M7,15.8l9.8,5.6" })))));
});
export default IconPackage;
//# sourceMappingURL=IconPackage.js.map